import { render } from "./FiveYearBarChart.vue?vue&type=template&id=2f00c537"
import script from "./FiveYearBarChart.vue?vue&type=script&lang=js"
export * from "./FiveYearBarChart.vue?vue&type=script&lang=js"

import "./FiveYearBarChart.vue?vue&type=style&index=0&id=2f00c537&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__